import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle token expiration — but NEVER redirect when the request itself was a login attempt
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !error.config?._skipAuthRedirect) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authService = {
  register: (data) => apiClient.post('/auth/register', data),
  login: (username, password) => apiClient.post('/auth/login', { username, password }, { _skipAuthRedirect: true }),
  verifyMFA: (code, tempToken) =>
    apiClient.post('/auth/mfa/verify', { code }, {
      headers: { Authorization: `Bearer ${tempToken}` },
    }),
  setupMFA: () => apiClient.post('/auth/mfa/setup', {}),
  confirmMFA: (secret, code) => apiClient.post('/auth/mfa/confirm', { secret, code }),
  disableMFA: () => apiClient.post('/auth/disable-mfa', {}),
  getCurrentUser: () => apiClient.get('/auth/me'),
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },
};

export default apiClient;
